angular.module('ApptBookApp').controller('AppointmentBookFiltersController',
  ['$scope', '$http', '$rootScope', 'restServer', 'appointmentBookModalService',
      'Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService',
    'appointmentBookGlobalsService',
      'services', 'employees', 'employeeCategories', 'resources', 'displayNoShows', 'gender',
    function ($scope, $http, $rootScope, restServer,
      modal, //TODO: use Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
      filterActions: Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService, globals,
      services, employees, employeeCategories, resources, gender) {

        $scope.genderFilter = gender;
        $scope.globals = globals;
      $scope.modal = modal;
      $scope.selectedEmployeeCategories = employeeCategories || [];
      $scope.selectedEmployees = employees || [];
      $scope.selectedEmployees.forEach(function (employee) {
        // If filter applied by clicking column header, need to fill in the deets for the employee
//        if (employee.weeklyFilter) {
//          restServer.getEmployee(employee.id, function (response) {
//            for (var i = 0; i < $scope.selectedEmployees.length; i++) {
//              if ($scope.selectedEmployees[i].id == response.id) {
//                $scope.selectedEmployees[i] = response;
//              }
//            }
//          });
//        }
      });
      $scope.selectedServices = services || [];
      $scope.selectedResources = resources || [];
      $scope.selections = {};

      $scope.serviceCriteria = { wildCardType: Meevo.Model.FilterWildcardType.Contains };

      $scope.deleteEmployee = function (index) {
        $scope.selectedEmployees.splice(index, 1);
      };

      $scope.deleteEmployeeCat = function (index) {
          $scope.selectedEmployeeCategories.splice(index, 1);
      };

      $scope.deleteService = function (index) {
        $scope.selectedServices.splice(index, 1);
      };

      $scope.deleteResource = function (index) {
          $scope.selectedResources.splice(index, 1);
      };

      $scope.saveFilters = function () {
          //$scope.genderFilter = $scope.gender;
          filterActions.updateFilters($scope.selectedEmployeeCategories, $scope.selectedEmployees, $scope.selectedServices, $scope.selectedResources, $scope.genderFilter);
        modal.hideModal();
        filterActions.filterBook();
      };

      $scope.clear = function () {
          $scope.selectedEmployeeCategories = [];
          $scope.selectedEmployees = [];
          $scope.selectedServices = [];
          $scope.selectedResources = [];
          $scope.genderFilter = null;
          filterActions.showAllEmployeesToday();
      };


      // Populates Lists
      $scope.employeeChanged = function () {
        if (!isObject($scope.selections.selectedEmployee) || $scope.selections.selectedEmployee.id == undefined) {
          return;
        }

        if (_.findWhere($scope.selectedEmployees, { id: $scope.selections.selectedEmployee.id }) == undefined) {
          $scope.selectedEmployees.push($scope.selections.selectedEmployee);
          $scope.selections.selectedEmployee = {};
          $scope.$apply();
        } else {
          $scope.selections.selectedEmployee = {};
          $scope.$apply();
        }
      }

      $scope.employeeCatChanged = function () {
          if (!isObject($scope.selections.selectedEmployeeCat) || $scope.selections.selectedEmployeeCat.id == undefined) {
              return;
          }

          if (_.findWhere($scope.selectedEmployeeCategories, { id: $scope.selections.selectedEmployeeCat.id }) == undefined) {
              $scope.selectedEmployeeCategories.push($scope.selections.selectedEmployeeCat);
              $scope.selections.selectedEmployeeCat = {};
              $scope.$apply();
          } else {
              $scope.selections.selectedEmployeeCat = {};
              $scope.$apply();
          }
      }

      $scope.serviceChanged = function () {
        if (!isObject($scope.selections.selectedService) || $scope.selections.selectedService.id == undefined) {
          return;
        }

        if (_.findWhere($scope.selectedServices, { id: $scope.selections.selectedService.id }) == undefined) {
          $scope.selectedServices.push($scope.selections.selectedService);
          $scope.selections.selectedService = {};
          $scope.$apply();
        } else {
          $scope.selections.selectedService = {};
          $scope.$apply();
        }
      }

      $scope.resourceChanged = function() {
          if (!isObject($scope.selections.selectedResource) || $scope.selections.selectedResource.id == undefined) {
              return;
          }

          if (_.findWhere($scope.selectedResources, { id: $scope.selections.selectedResource.id }) == undefined) {
              $scope.selectedResources.push($scope.selections.selectedResource);
          }
          $scope.selections.selectedResource = {};
          $scope.$apply();
      }
    }
  ]);